// import earrings prototype object
import { EarringsProduct } from '@facecake/fmt-react-tryon/';

// load array of glasses products
const earrings = [
  { 
    brandName: 'BaubleBar',
    productName: 'Crispin Drop',
    price: '$10.00',
    productPdpUrl: 'http://www.pntra.com/t/TUJGRkVMTEJGRk5NSEpCRklITE5N?url=https%3A%2F%2Fwww.baublebar.com%2Fproduct%2F29790-crispin-drops-earrings.html',
    productThumb: {
      unselected: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/thumbs_earrings_crispin.png',
      selected: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/thumbs_earrings_crispin_over.png',
    },
    earringsProduct: new EarringsProduct({
      productId: 1,
      scaleFactor: 1.5,
      productImages: [
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/Bauble-Bar-Crispin-Drop-Earrings-Multi/Bauble-Bar-Crispin-Drop-Earrings-Multi-1.png',
          w: 63, h: 119, offsetY: -60, },
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/Bauble-Bar-Crispin-Drop-Earrings-Multi/Bauble-Bar-Crispin-Drop-Earrings-Multi-2.png',
          w: 66, h: 92,  offsetY: -8, },
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/Bauble-Bar-Crispin-Drop-Earrings-Multi/Bauble-Bar-Crispin-Drop-Earrings-Multi-3.png',
          w: 85, h: 105, offsetY: -8, },
      ],  
    }),
  }, { 
    brandName: 'Kendra Scott',
    productName: 'Alex Gold Drop',
    price: '$55.00',
    productPdpUrl: 'http://www.anrdoezrs.net/links/7568311/type/dlg/https://www.kendrascott.com/jewelry/categories/earrings/842177093962.html',
    productThumb: {
      unselected: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/thumbs_earrings_alex.png',
      selected: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/thumbs_earrings_alex_over.png',
     },
    earringsProduct: new EarringsProduct({
      productId: 2,
      scaleFactor: 1.5,
      productImages: [
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/Alex-Earrings-in-Rose-Quartz/Alex-Earrings-in-Rose-Quartz_Hook.png',
          w: 19, h: 58, offsetY: -29},
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/Alex-Earrings-in-Rose-Quartz/Alex-Earrings-in-Rose-Quartz_Bezel.png',
          w: 20, h: 189, offsetY: -20},
      ],
    }),
  }, { 
    brandName: 'BaubleBar',
    productName: 'Tahir Drop',
    price: '$42.00',
    productPdpUrl:'http://www.gopjn.com/t/TUJGRkVMTEJGRk5NSEpCRklITE5N?url=https%3A%2F%2Fwww.baublebar.com%2Fproduct%2F39400-tahir-drop-earrings',
    productThumb: {
      unselected: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/thumb_earrings_tahirDrop.png',
      selected: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/thumb_earrings_tahirDrop_over.png',
    },
    earringsProduct: new EarringsProduct({
      productId: 3,
      scaleFactor: 2,
      productImages: [
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/BaublebarTahir-Drop-Earrings/Tahir-Drop-Top.png',
          w: 20, h: 95, offsetY: -44},
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/BaublebarTahir-Drop-Earrings/Tahir-Drop-Bottom.png',
          w: 20, h: 105, offsetY: -25},
      ],
    }),
  }, { 
    brandName: 'BaubleBar',
    productName: 'Sydney Hoop',
    price: '$22.00',
    productPdpUrl: 'http://www.pntrac.com/t/TUJGRkVMTEJGRk5NSEpCRklITE5N?url=https%3A%2F%2Fwww.baublebar.com%2Fproduct%2F34817-sydney-hoop-earrings%3Fsku%3D34817',
    productThumb: {
      unselected: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/thumb_earrings_sydneyHoop.png',
      selected: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/thumb_earrings_sydneyHoop_over.png',
    },
    earringsProduct: new EarringsProduct({
      productId: 4,
      scaleFactor: 1.5,
      productImages: [
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/Baublebar-Sydney-Hoop-Earrings/Sydney-Hoop-Earrings_Hook.png',
          w: 20, h: 54, offsetY: -24},
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/Baublebar-Sydney-Hoop-Earrings/Sydney-Hoop-Earrings_Bezel.png',
          w: 20, h: 140, offsetY: 40},
      ],
    }),
  }, { 
    brandName: 'Kendra Scott',
    productName: 'Rose Gold Filigree',
    price: '$55.00',
    productPdpUrl: 'https://click.linksynergy.com/deeplink?id=6V70MFsWQOU&mid=1237&murl=https%3A%2F%2Fshop.nordstrom.com%2Fs%2Fkendra-scott-elle-filigree-drop-earrings%2F3296281',
    productThumb: {
      unselected: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/thumb_glasses_gucci.png',
      selected: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/thumb_glasses_gucci_over.png',
    },
    earringsProduct: new EarringsProduct({
      productId: 5,
      scaleFactor: 2.5,
      productImages: [
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/Tallulah-Shoulder-Duster-Hematite_1.png',
          w: 23, h: 88, offsetY: -44},
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/Tallulah-Shoulder-Duster-Hematite_2.png',
          w: 23, h: 83, offsetY: -25},
        { imageUrl: 'https://media.facecake.com/dev/cake-framework/testassets/earrings/Tallulah-Shoulder-Duster-Hematite_3.png',
          w: 23, h: 88, offsetY: -15}
      ],
    }),
  },
];


export default earrings;